import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from '#src/pages/PrizePoolContenderPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const NBAPrizePoolPage = () => {
  const { leaderboard } = useTypedParams<PageParams>();

  return <PrizePoolContenderPage leaderboard={leaderboard} />;
};

export default NBAPrizePoolPage;
